var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncidenciaProceso = function SvgIncidenciaProceso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "incidencia_proceso_svg__Capa_2",
    viewBox: "0 0 50.29 50.29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "incidencia_proceso_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.29,
    height: 49.29,
    x: 0.5,
    y: 0.5,
    rx: 8.85,
    ry: 8.85,
    strokeMiterlimit: 10,
    fill: "#fffbeb",
    stroke: "#f9dba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.32 17.78v-6.49",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#f7a90b",
    strokeLinecap: "round",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.91 19.83 4.59-4.59",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#f7a90b",
    strokeLinecap: "round",
    strokeWidth: "2px",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.71 24.52h6.48",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#f7a90b",
    strokeLinecap: "round",
    strokeWidth: "2px",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.66 29.11 4.58 4.58",
    opacity: 0.55,
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#f7a90b",
    strokeLinecap: "round",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.97 30.9v6.49",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#f7a90b",
    strokeLinecap: "round",
    strokeWidth: "2px",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.38 28.85-4.59 4.59",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#f7a90b",
    strokeLinecap: "round",
    strokeWidth: "2px",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.58 24.16H12.1",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#f7a90b",
    strokeLinecap: "round",
    strokeWidth: "2px",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.63 19.58-4.59-4.59",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#f7a90b",
    strokeLinecap: "round",
    strokeWidth: "2px",
    opacity: 0.05
  }))));
};
export default SvgIncidenciaProceso;